import { render, staticRenderFns } from "./ModalFooterRegulation.vue?vue&type=template&id=d3f0b28e&scoped=true&"
import script from "./ModalFooterRegulation.vue?vue&type=script&lang=js&"
export * from "./ModalFooterRegulation.vue?vue&type=script&lang=js&"
import style0 from "./ModalFooterRegulation.vue?vue&type=style&index=0&id=d3f0b28e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3f0b28e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VCard,VCardText,VCardTitle,VDialog})
